import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_8px = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_8px}`);
